import { render, staticRenderFns } from "./ReferenceDataImport.vue?vue&type=template&id=3728ae9f&scoped=true&"
import script from "./ReferenceDataImport.vue?vue&type=script&lang=js&"
export * from "./ReferenceDataImport.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceDataImport.vue?vue&type=style&index=0&id=3728ae9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3728ae9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3728ae9f')) {
      api.createRecord('3728ae9f', component.options)
    } else {
      api.reload('3728ae9f', component.options)
    }
    module.hot.accept("./ReferenceDataImport.vue?vue&type=template&id=3728ae9f&scoped=true&", function () {
      api.rerender('3728ae9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_reference-data/components/ReferenceDataImport.vue"
export default component.exports